export class ContatoreStatoNoteDTO {
  totali: number;
  liberi: number;
  inCarico: number;
}

// { [tipoNota: string]: { [stato: string]: ContatoreStatoNoteDTO } }
export class ContatoreNoteDTO {
  [tipoNota: string]: { [stato: string]: ContatoreStatoNoteDTO };
}
